import { _ } from "../../polyglot/polyglot.js";
import { convertRenderableToHTML } from "../../helpers/dom-util.js";
import introjs from "intro.js";

/**
 * `HelpWizard` builds help steps to be used in a wizard to guide the user
 * through a document.
 *
 * It internally uses the intro.js library (see https://introjs.com/).
 *
 * @param {function} stepsBuilder - Function that returns an array of help
 * step definitions. See the `help` method in
 * `accounting/shared/accountingDocument` for the help step definitions.
 */
export default class HelpWizard {
	constructor({ stepsBuilder }) {
		this._stepsBuilder = stepsBuilder;
	}

	start() {
		introjs()
			.setOptions({
				steps: this._buildSteps(),
				nextLabel: _("Next"),
				prevLabel: _("Back"),
				doneLabel: _("Done"),
			})
			.start();
	}

	/**
	 * Return an array of help steps as defined in intro.js at
	 * https://introjs.com/docs/examples/basic/json-config
	 */
	_buildSteps() {
		return this._stepsBuilder()
			.filter(
				(step) =>
					// `visible` is optional and means `true` if it is undefined:
					step.visible !== false,
			)
			.map((step) => ({
				...step,
				title: step.title && step.title.toString(),
				intro: convertRenderableToHTML(step.content),
				element: this._buildQuerySelector(step.element),
			}));
	}

	/**
	 * Return a DOM element selected from its "data-help" attribute value.
	 */
	_buildQuerySelector(value) {
		return value && document.querySelector(`[data-help=${value}]`);
	}
}
